import { createContext, useContext } from 'react'
import { AuthModel } from '~/entities/auth'
import { CategoriesModel } from '~/entities/category-list'
import { ProductsModel } from '~/entities/products'
import { StoresModel } from '~/entities/stores/model'
import { OrdersModel } from '~/entities/orders/model'
import { WarehousesModel } from '~/entities/warehouses/model'
import { RegistrationModel } from '~/entities/registration'
import MarketingStore from '~/entities/marketing/model'
import MainModel from '~/entities/main'
import { GlobalModel } from '~/shared/store/global-store'
import { DiscountStore } from '~/entities/marketing/discount/model'
import { CouponStore } from '~/entities/marketing/coupon/model'
import SliderStore from '~/entities/marketing/slider/model'
import UsersStore from '~/entities/users/model'
import { RetailStore } from '~/entities/retail-filter/model'
import { DeliveryStore } from '~/entities/delivery/model'
import KvantsStore from '~/entities/kvants'
import { FBOStore } from '~/entities/fbo'
import InventoryStore from '~/entities/inventory'
import { InformationStore } from '~/entities/information'
import { OptionsStores } from '~/entities/options'
import { KitsStore } from '~/entities/kits/model'
import { ReturnsStore } from '~/entities/returns/model'
import { ReportsStore } from '~/entities/reports/model'
import { BadgesStore } from '~/entities/badges/model'
import { PrinterStore } from '~/entities/printers/model'
import { AbandonedCartsStore } from '~/entities/abandoned/model'
import { CustomersStore } from '~/entities/customers/model'
import UserLogsActivitiesStore from '~/entities/user-logs-activities/model'
import { RealtimeModel } from '~/entities/realtime'
import { MaterialsStore } from '~/entities/materials/model'
import { FeaturePageStore } from '~/entities/feature-page/model'
import { SettingShippingStore } from '~/entities/setting-shipping/model'
import { BrandsStore } from '~/entities/brands/model'
import { ReviewsStore } from '~/entities/reviews/model'

import { CostingStore } from '~/entities/costing/model'

import TicketsStore from '~/entities/tickets'
import { AutopurchasesStore } from '~/entities/autopurchases/model'
import { PurchaseStore } from '~/entities/purchase/model'
import BlogPostsStore from '~/entities/blog-posts/model'
import BlogTagsStore from '~/entities/blog-tags/model'
import { ProductionStore } from '~/entities/production/model'

class Store {
  globalStore = new GlobalModel()

  registrationStore = new RegistrationModel()

  authStore = new AuthModel()

  realtimeStore = new RealtimeModel(this.authStore)

  mainStore = new MainModel()

  productsStore = new ProductsModel()

  categoriesStore = new CategoriesModel()

  storesStore = new StoresModel()

  ordersStore = new OrdersModel()

  warehousesStore = new WarehousesModel()

  marketingStore = new MarketingStore()

  discountStore = new DiscountStore()

  couponsStore = new CouponStore()

  sliderStore = new SliderStore()

  usersStore = new UsersStore()

  retailStore = new RetailStore()

  deliveryStore = new DeliveryStore()

  kvantsStore = new KvantsStore()

  fboStore = new FBOStore()

  inventoryStore = new InventoryStore()

  informationStore = new InformationStore()

  optionsStore = new OptionsStores()

  kitsStore = new KitsStore()

  returnsStore = new ReturnsStore()

  reportsStore = new ReportsStore()

  badgesStore = new BadgesStore()

  printerStore = new PrinterStore()

  abandonedStore = new AbandonedCartsStore()

  customersStore = new CustomersStore()

  userLogsActivitiesStore = new UserLogsActivitiesStore()

  materialsStore = new MaterialsStore()

  featurePageStore = new FeaturePageStore()

  settingShippingStore = new SettingShippingStore()

  brandsStore = new BrandsStore()

  costingStore = new CostingStore()

  ticketsStore = new TicketsStore()

  autopurchasesStore = new AutopurchasesStore()

  purchaseStore = new PurchaseStore()

  blogPostsStore = new BlogPostsStore()

  blogTagsStore = new BlogTagsStore()

  reviewsStore = new ReviewsStore()

  productionStore = new ProductionStore()
}

export const store = new Store()

export const StoreContext = createContext(store)

export const StoreProvider = ({ children }: { children: React.ReactNode }) => (
  <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
)

export const useStore = () => useContext(StoreContext)
